import type { LocalizedDict } from '../index'
import { formatDate } from '../../lib/datetime'
import {
  fmtDate as fmtDateEn,
  normalizePhase,
  relTime as relTimeEn,
  type SampleStatus,
} from '../../features/samples/lib'

// Shared sample-domain text: phase names, priority names and the relative /
// absolute timestamp formatters. English delegates to the original helpers in
// features/samples/lib so the rendered English text is unchanged.

export type SamplesCommonStrings = {
  phases: Record<SampleStatus, string>
  phaseLabel: (key: string | null | undefined) => string
  priorities: Record<'urgent' | 'normal' | 'low', string>
  relTime: (ts: number | null | undefined) => string
  fmtDate: (ts: number | null | undefined) => string
}

const PHASES_EN: Record<SampleStatus, string> = {
  draft: 'Draft',
  ready_for_factory: 'Ready for Factory',
  confirmed: 'In Production',
  sample_ready: 'Sample Ready',
  shipped: 'Shipped',
  received: 'Received',
}

const PHASES_TR: Record<SampleStatus, string> = {
  draft: 'Taslak',
  ready_for_factory: 'Fabrikaya hazır',
  confirmed: 'Üretimde',
  sample_ready: 'Numune hazır',
  shipped: 'Kargoda',
  received: 'Teslim alındı',
}

function relTimeTr(ts: number | null | undefined): string {
  if (!ts) return '—'
  const diff = Date.now() / 1000 - ts
  if (diff < 60) return 'az önce'
  if (diff < 3600) return `${Math.floor(diff / 60)} dk önce`
  if (diff < 86400) return `${Math.floor(diff / 3600)} sa önce`
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)} gün önce`
  return formatDate(new Date(ts * 1000), { day: '2-digit', month: 'short' })
}

function fmtDateTr(ts: number | null | undefined): string {
  if (!ts) return '—'
  return formatDate(new Date(ts * 1000), { day: '2-digit', month: 'short', year: 'numeric' })
}

export const samplesCommonI18n: LocalizedDict<SamplesCommonStrings> = {
  en: {
    phases: PHASES_EN,
    phaseLabel: (key) => PHASES_EN[normalizePhase(key)],
    priorities: { urgent: 'Urgent', normal: 'Normal', low: 'Low' },
    relTime: relTimeEn,
    fmtDate: fmtDateEn,
  },
  tr: {
    phases: PHASES_TR,
    phaseLabel: (key) => PHASES_TR[normalizePhase(key)],
    priorities: { urgent: 'Acil', normal: 'Normal', low: 'Düşük' },
    relTime: relTimeTr,
    fmtDate: fmtDateTr,
  },
}
